import type { CustomerSurveySource } from './customerSurveyApi';
import { clearLoginDelay } from './surveyLoginDelay';

const KEY_PREFIX = 'customer_survey_checked';

const SHOWN_KEY = 'customer_survey_shown';

const SESSION_TOKEN_KEY = 'customer_survey_session_token';

export function hasBeenShown(): boolean {
  try {
    return sessionStorage.getItem(SHOWN_KEY) === '1';
  } catch {
    return false;
  }
}

export function markShown(): void {
  try {
    sessionStorage.setItem(SHOWN_KEY, '1');
  } catch {
    return;
  }
}

const checkedKey = (accessToken: string, source: CustomerSurveySource) =>
  `${KEY_PREFIX}_${source}_${accessToken}`;

export function hasChecked(token: string, source: CustomerSurveySource): boolean {
  try {
    return sessionStorage.getItem(checkedKey(token, source)) === '1';
  } catch {
    return false;
  }
}

export function markChecked(token: string, source: CustomerSurveySource): void {
  try {
    sessionStorage.setItem(checkedKey(token, source), '1');
  } catch {
    return;
  }
}

export function clearChecked(token: string, source: CustomerSurveySource): void {
  try {
    sessionStorage.removeItem(checkedKey(token, source));
  } catch {
    return;
  }
}

export function clearCustomerSurveySessionChecks(): void {
  clearLoginDelay();

  try {
    const keys: string[] = [];
    for (let i = 0; i < sessionStorage.length; i += 1) {
      const key = sessionStorage.key(i);
      if (key && key.startsWith('customer_survey_')) keys.push(key);
    }
    keys.forEach((key) => sessionStorage.removeItem(key));
  } catch {
    return;
  }
}

export function syncCustomerSurveySessionToken(token: string): void {
  if (!token) return;

  try {
    const previousToken = sessionStorage.getItem(SESSION_TOKEN_KEY);
    if (previousToken === token) return;

    clearCustomerSurveySessionChecks();
    sessionStorage.setItem(SESSION_TOKEN_KEY, token);
  } catch {
    return;
  }
}
